
import { remove, apiToggle, combineReducers } from './common';

import {
  REQUEST_INVITATIONS_SUCCESS,
  ACCEPT_INVITATION_ERROR,
  ACCEPT_INVITATION_SUCCESS,
  DELETE_INVITATION_SUCCESS,
  ACCEPT_INVITATION,
  DELETE_INVITATION
} from '../actions/invitations';

import {
  REQUEST_SUBSCRIPTION_INVITATIONS_SUCCESS, INVITE_USERS_SUCCESS
} from '../actions/subscriptions';

/**
 * Invitation errors reducer
 * @param {Object} state an invitation
 * @param {Object} action 
 */
const errors = (state = [], action) => {
  switch (action.type) {
    case ACCEPT_INVITATION_ERROR:
      return state.concat([action.error.errors])
    default:
      return state;
  }
}

/** 
 * Invitation additonnal states
*/
const clientStates = combineReducers({
  // invitation errors
  errors,
  // true when accepting invitation
  accepting: apiToggle(ACCEPT_INVITATION),
  // true when deleting invitation
  deleting: apiToggle(DELETE_INVITATION)
})

/**
 * Invitation reducer
 * @param {Object} state an invitation
 * @param {Object} action 
 */
const invitation = (state = {}, action) => ({
  ...state,
  ...action.invitation,
  ...clientStates(state, action)
});

/**
 * Generates a reducer that updates the corresponding invitation 
 * in the invitation store
 * @param {String} id An invitation ID
 */
const withId = id => (state = {}, action) => ({
  ...state,
  [id]: {
    id,
    ...invitation(state[id], action)
  }
});

/**
 * Adds an invitation to the store
 * @param {Object} state invitations by ID
 * @param {Object} invitation an invitation ID
 */
const add = (state, invitation) =>
  withId(invitation.id)(state, { invitation });

/**
 * Invitations reducer
 * @param {Object} state invitations by id
 * @param {Object} action 
 */
const invitations = (state = {}, action) => {

  const { invitation, invitationId } = action;

  if (invitationId) {
    // if the action has an invitationId (accept, delete)
    switch (action.type) {
      case ACCEPT_INVITATION_SUCCESS:
      case DELETE_INVITATION_SUCCESS:
      // when an invitation has been accepted or deleted, 
      // it must be deleted from the store
        return remove(state, item => item.id === invitationId);
      default:
      // otherwise, just forward the action
        return withId(invitationId)(state, action);
    }
  }

  if (invitation) {
    // if action has an invitation, just forward action
    return withId(invitation.id)(state, action);
  }


  switch (action.type) {
    case REQUEST_INVITATIONS_SUCCESS:
    case REQUEST_SUBSCRIPTION_INVITATIONS_SUCCESS:
      // invitations have been received for a user or for a subscription
      return action.items.reduce(add, state);
    case INVITE_USERS_SUCCESS:
      // users have been invited to a subscription
      return action.invitations.reduce(add, state);
    default:
      return state;
  }

}

export default invitations;

/** 
 * Invitation filters
 * FIXME: move to helpers
*/
export const filters = {
  byEmail: email =>
    invitation => invitation.email === email,
  bySubscriptionId: id =>
    invitation => invitation.licence && invitation.licence.subscriptionId === id,
  byProductId: id =>
    invitation => invitation.licence 
      && invitation.licence.plan
      && invitation.licence.plan.product
      && invitation.licence.plan.product.id === id,
  notForSubscriptions: subscriptions =>
    invitation => !subscriptions.find(s => s.id === invitation.licence.subscriptionId)
}



// WEBPACK FOOTER //
// ./src/reducers/invitations.js